"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchInviteRequestF = void 0;
var tslib_1 = require("tslib");
var createErrorAction_1 = require("./../../actionCreators/createErrorAction");
var effects_1 = require("redux-saga/effects");
var actions_1 = require("../../constants/actions");
var getObjectFirstItem_1 = require("../../utilities/get/getObjectFirstItem");
var updateInviteClient_1 = require("../../functions/utilities/ref/update/updateInviteClient");
var firestore_1 = require("firebase/firestore");
var description = 'patchInviteRequestF';
var patchInviteRequestF = function () {
    var patchInviteRequestAction, requestValues, _a, inviteId, firstInvite, error_1;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!1) return [3 /*break*/, 12];
                return [4 /*yield*/, (0, effects_1.take)([
                        actions_1.PATCH_INVITES_REQUEST,
                    ])];
            case 1:
                patchInviteRequestAction = _b.sent();
                requestValues = patchInviteRequestAction.requestValues;
                _a = (0, getObjectFirstItem_1.getObjectFirstItem)(requestValues.items), inviteId = _a.key, firstInvite = _a.item;
                if (!(firstInvite && inviteId)) return [3 /*break*/, 9];
                _b.label = 2;
            case 2:
                _b.trys.push([2, 5, , 8]);
                // TODO: figure how to handle types because invite is all optional
                return [4 /*yield*/, (0, updateInviteClient_1.updateInviteClient)({
                        // TODO: start using util function to enforce types
                        firestore: (0, firestore_1.getFirestore)(),
                        workspaceId: firstInvite.workspaceId,
                        inviteId: inviteId,
                        invite: firstInvite.data,
                    })];
            case 3:
                // TODO: figure how to handle types because invite is all optional
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'PATCH_INVITES_SUCCESS',
                        description: 'patchInviteRequestF',
                        successValues: requestValues,
                        requestValues: requestValues,
                    })];
            case 4:
                _b.sent();
                return [3 /*break*/, 8];
            case 5:
                error_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                        description: description,
                        error: error_1,
                    }))];
            case 6:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'PATCH_INVITES_FAILURE',
                        description: 'patchInviteRequestF',
                        requestValues: requestValues,
                    })];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                    description: description,
                }))];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
exports.patchInviteRequestF = patchInviteRequestF;
